export const CANADA_POSTAL_CODE_FIRST_LETTERS_BY_STATE_CODE: Record<string, string[]> = {
  AB: ['T'],
  BC: ['V'],
  MB: ['R'],
  NB: ['E'],
  NL: ['A'],
  NT: ['X'],
  NS: ['B'],
  NU: ['X'],
  ON: ['K', 'L', 'M', 'N', 'P'],
  PE: ['C'],
  QC: ['G', 'H', 'J'],
  SK: ['S'],
  YT: ['Y']
};
